export enum ArchivedStatus {
    Pending = 1,
    InProgress = 2,
    Accepted = 3,
    Rejected = 4,
    Granted = 5,
    Resent = 6,
}
